export default "__VITE_ASSET__CkG4BqZ3__"